import _ from 'lodash'
import moment from 'moment'
import FileSaver from 'file-saver'
import {stringify} from 'csv-stringify/browser/esm'
import {RRule} from 'rrule'
import dbCodes from '../../server/dbCodes.js'
import languages from '../../server/languages.js'
import convertStatus from '../../server/utils/convertStatus.js'
import {Colors} from '../components/UI/index.js'
import {formatDuration} from '../../utils/utils.js'
import {formatPrice, parsePrice} from '../../utils/price.js'
import webshopKeyToName from './webshopNames.js'
import Languages from '@utils/Languages.js'
import {getColliTypeName} from '@utils/getColliTypeName.js'
import {getOrderFeesText} from '@utils/orderFees.js'
import {getRouteExportColumns} from '../components/routes/routeSummary.js'

function countColliByType(order, reseller, colloType) {
    if (!order?.colli?.length || !colloType) {
        return 0
    }

    const legacyTypeName = dbCodes.colloTypes[colloType]

    const resellerColliType = reseller?.settings?.orders?.colliTypes?.find((type) => {
        return type.id === colloType || type.name === colloType || (legacyTypeName && type.name === legacyTypeName)
    })

    return order.colli.filter((collo) => {
        if (!collo?.type) {
            return false
        }

        if (collo.type === colloType || (legacyTypeName && collo.type === legacyTypeName)) {
            return true
        }

        return !!(resellerColliType && (collo.type === resellerColliType.id || collo.type === resellerColliType.name))
    }).length
}

/**
 * @deprecated
 */
function ordersToCSV(reseller, orders, customers) {
    const csvContent = [['_id', 'Datum', 'Debiteurnummer', 'Klant', 'Contact', 'Emailadres', 'Telefoon', 'Ophaaladres: Stopnummer', 'Ophaaladres: Naam', 'Ophaaladres: T.a.v.', 'Ophaaladres: Straat', 'Ophaaladres: Nr', 'Ophaaladres: Toevoeging', 'Ophaaladres: 2e adres regel', 'Ophaaladres: Postcode', 'Ophaaladres: Plaats', 'Ophaaladres: Land', 'Ophaaladres: Instructies', 'Ophaaladres: Starttijd', 'Ophaaladres: Eindtijd', 'Ophaaladres: Status', 'Ophaaladres: Opmerking koerier', 'Bezorgadres: Stopnummer', 'Bezorgadres: Naam', 'Bezorgadres: T.a.v.', 'Bezorgadres: Straat', 'Bezorgadres: Nr', 'Bezorgadres: Toevoeging', 'Bezorgadres: 2e adres regel', 'Bezorgadres: Postcode', 'Bezorgadres: Plaats', 'Bezorgadres: Land', 'Bezorgadres: Instructies', 'Bezorgadres: Starttijd', 'Bezorgadres: Eindtijd', 'Bezorgadres: Opties', 'Bezorgadres: Status', 'Bezorgadres: Opmerking koerier', 'Prijs', 'Toeslagen', 'Referentie', 'Track & Trace', 'Track & Trace Link', 'Status', 'Opgehaald om', 'Bezorgd om', 'Bezorgd om (ISO 8601)', 'ETA', 'Route', 'Koerier', 'Opmerkingen', 'Inhoud: Aantal', 'Inhoud: Omschrijving', 'Inhoud: Gewicht (kg)', 'Inhoud: Lengte (cm)', 'Inhoud: Breedte (cm)', 'Inhoud: Hoogte (cm)']]

    if (reseller.settings.orders && reseller.settings.orders.monitorTemperature) {
        csvContent[0].push('Min temperatuur', 'Max temperatuur', 'Laagste temperatuur', 'Hoogste temperatuur', 'Min/Max temperatuur overschreden')
    }

    orders.map((order) => {
        const customer = customers[order.customer]
        const line = []

        const pickupAddress = _.find(order.addresses, (address) => address.type === 'pickup') || {}
        const deliveryAddress = _.find([...order.addresses].reverse(), (address) => address.type === 'delivery') || {}
        deliveryAddress.options = []

        if (deliveryAddress.gpsRequired) {
            deliveryAddress.options.push('GPS verplicht')
        }

        if (deliveryAddress.scanRequired) {
            deliveryAddress.options.push('Scan verplicht')
        }

        if (deliveryAddress.imageRequired) {
            deliveryAddress.options.push('Foto verplicht')
        }

        if (deliveryAddress.signatureRequired) {
            deliveryAddress.options.push('Handtekening')
        }

        if (deliveryAddress.nameRequired && !deliveryAddress.signatureRequired) {
            deliveryAddress.options.push('Naam verplicht')
        }

        if (deliveryAddress.signatureNeighbors) {
            deliveryAddress.options.push('Handtekening buren')
        }

        if (deliveryAddress.statedAddressOnly) {
            deliveryAddress.options.push('Niet bij buren')
        }

        if (deliveryAddress.mailboxDelivery) {
            deliveryAddress.options.push('Brievenbuspakket')
        }

        if (deliveryAddress.ageCheck) {
            deliveryAddress.options.push(`Leeftijdscheck ${deliveryAddress.minimumAge}+`)
        }

        if (deliveryAddress.idCheck) {
            deliveryAddress.options.push('ID check')
        }

        if (deliveryAddress.verificationCode) {
            deliveryAddress.options.push('Verfificatie code')
        }

        let pickupStatus
        let deliveryStatus

        if (pickupAddress) {
            pickupStatus = pickupAddress.pickupStatus || convertStatus.addressToPickupStatus(order, pickupAddress)
        }

        if (deliveryAddress) {
            deliveryStatus = deliveryAddress.deliveryStatus || convertStatus.addressToDeliveryStatus(order, deliveryAddress)
        }

        line.push(order._id)
        line.push(order.date)
        line.push(customer ? customer.debtorCode : '')
        line.push(order.customerAddress?.name || '')
        line.push(order.contact || '')
        line.push(order.email)
        line.push(order.phone)
        line.push(pickupAddress.stopNumber ? pickupAddress.stopNumber : '')
        line.push(pickupAddress.name)
        line.push(pickupAddress.attention)
        line.push(pickupAddress.street)
        line.push(pickupAddress.nr)
        line.push(pickupAddress.addition)
        line.push(pickupAddress.street2)
        line.push(pickupAddress.postalCode)
        line.push(pickupAddress.city)
        line.push(pickupAddress.country)
        line.push(pickupAddress.instructions)
        line.push(pickupAddress.startTime)
        line.push(pickupAddress.endTime)
        line.push(pickupStatus ? dbCodes.pickupStatus[pickupStatus] : '')
        const lastPickupEntryWithComment = [...order.history].reverse().find((obj) => obj.type === 'pickup' && obj.comment)
        if (lastPickupEntryWithComment) {
            line.push(lastPickupEntryWithComment.comment)
        } else {
            line.push(pickupAddress.comment)
        }
        line.push(deliveryAddress.stopNumber ? deliveryAddress.stopNumber : '')
        line.push(deliveryAddress.name)
        line.push(deliveryAddress.attention)
        line.push(deliveryAddress.street)
        line.push(deliveryAddress.nr)
        line.push(deliveryAddress.addition)
        line.push(deliveryAddress.street2)
        line.push(deliveryAddress.postalCode)
        line.push(deliveryAddress.city)
        line.push(deliveryAddress.country)
        line.push(deliveryAddress.instructions)
        line.push(deliveryAddress.startTime)
        line.push(deliveryAddress.endTime)
        line.push(deliveryAddress.options?.join(', '))
        line.push(deliveryStatus ? dbCodes.deliveryStatus[deliveryStatus] : '')
        const lastDeliveryEntryWithComment = [...order.history].reverse().find((obj) => obj.type === 'delivery' && obj.comment)
        if (lastDeliveryEntryWithComment) {
            line.push(lastDeliveryEntryWithComment.comment)
        } else {
            line.push(deliveryAddress.comment)
        }
        line.push(`€ ${order.price.replace(',', '.')}`)
        line.push(getOrderFeesText(order, reseller))
        line.push(order.reference)
        line.push(order.trackTrace)
        line.push(`https://app.veloyd.nl/track&trace/${order.trackTrace}`)
        line.push(dbCodes.status[order.status])
        line.push(pickupAddress.timeOfArrival || '')
        line.push(deliveryAddress.timeOfArrival || '')
        line.push(deliveryAddress.timeOfArrival ? moment(`${order.date} ${deliveryAddress.timeOfArrival}`).toISOString(true) : '')
        line.push(deliveryAddress.plannedTimeOfArrival || '')
        line.push(order.routeName)
        line.push((order.routeId ? order.messengerName : order.messenger) || '') // order.messenger is DEPRECATED
        line.push(order.notes)
        line.push(order.colli.length || 0)
        line.push(order.colli[0]?.description || '')
        line.push(((order.colli[0]?.weight || 0) / 1000).toFixed(2))
        line.push(order.colli[0]?.length || 0)
        line.push(order.colli[0]?.width || 0)
        line.push(order.colli[0]?.height || 0)

        if (order.monitorTemperature) {
            line.push(order.minTemperature)
            line.push(order.maxTemperature)
            line.push(order.lowestTemperature)
            line.push(order.highestTemperature)
            line.push(order.lowestTemperature < order.minTemperature || order.highestTemperature > order.maxTemperature ? 'Ja' : 'Nee')
        }

        csvContent.push(line)
    })

    return csvContent
}

const EXPORT_CHUNK_SIZE = 250

/**
 * Resolves after the next paint so pending loading states are visible before heavy work starts
 */
export function waitForPaint() {
    return new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve)))
}

/**
 * Pushes a line per item to csvContent, yielding to the browser between chunks so loading states can render
 */
async function pushInChunks(csvContent, items, getLine, onProgress) {
    onProgress?.(0, items.length)

    // Wait for the next paint so the loading state is visible before the work starts
    await waitForPaint()

    for (let i = 0; i < items.length; i++) {
        csvContent.push(getLine(items[i]))

        if ((i + 1) % EXPORT_CHUNK_SIZE === 0) {
            onProgress?.(i + 1, items.length)
            await new Promise((resolve) => setTimeout(resolve))
        }
    }

    onProgress?.(items.length, items.length)
}

async function ordersToCSVTemplate(reseller, orders, customers, routes, vehicles, template, onProgress) {
    // Resolve columns once, getColumns builds the full column list on every call
    const columns = getColumns(template.method, reseller)
    const foundColumns = template.columns.map((column) => columns.find((c) => c.value === column))

    const csvContent = [[]]
    foundColumns.forEach((foundColumn) => {
        const label = `${foundColumn?.typeLabel}: ${foundColumn?.label}`

        csvContent[0].push(label)
    })

    let rows = []
    let getLine = () => []

    if (template.method === 'order') {
        rows = orders

        getLine = (order) => {
            return foundColumns.map((foundColumn) => {
                if (!foundColumn) {
                    return ''
                } else if (foundColumn.get) {
                    let address = order.addresses[0]

                    if (foundColumn.typeLabel === 'Ophaaladres') {
                        address = order.addresses.find((address) => address.type === 'pickup')
                    }

                    if (foundColumn.typeLabel === 'Bezorgadres') {
                        address = order.addresses.find((address) => address.type === 'delivery')
                    }

                    return typeof foundColumn.get === 'function' ? foundColumn.get({reseller, order, customers, address, collo: order.colli[0], routes, vehicles}) : foundColumn.get
                } else {
                    return order[foundColumn.value]
                }
            })
        }
    }

    if (template.method === 'address') {
        rows = orders.flatMap((order) => {
            return order.addresses.map((address) => ({
                order,
                address
            }))
        })

        getLine = ({address, order}) => {
            return foundColumns.map((foundColumn) => {
                if (!foundColumn) {
                    return ''
                } else if (foundColumn.get) {
                    let thisAddress = structuredClone(address)

                    const collo = order.colli.find((c) => {
                        if (typeof c.pickupAddressIndex === 'number' && address.type === 'pickup') {
                            return c.pickupAddressIndex === address.index
                        }

                        if (typeof c.deliveryAddressIndex === 'number' && address.type === 'delivery') {
                            return c.deliveryAddressIndex === address.index
                        }
                    }) || {}

                    if (foundColumn.typeLabel === 'Ophaaladres') {
                        thisAddress = address.type === 'pickup' && address
                    }

                    if (foundColumn.typeLabel === 'Bezorgadres') {
                        thisAddress = address.type === 'delivery' && address
                    }

                    // @ts-ignore
                    return typeof foundColumn.get === 'function' ? foundColumn.get({reseller, address: thisAddress, order, customers, collo}) : foundColumn.get
                } else {
                    return order[foundColumn.value]
                }
            })
        }
    }

    if (template.method === 'collo') {
        rows = orders.flatMap((order) => {
            return order.colli.map((collo) => ({
                order,
                collo
            }))
        })

        getLine = ({collo, order}) => {
            return foundColumns.map((foundColumn) => {
                if (!foundColumn) {
                    return ''
                } else if (foundColumn.get) {
                    let address = {}

                    address = order.addresses.find((address) => address.index === collo?.pickupAddressIndex || address.index === collo?.deliveryAddressIndex) || {}

                    if (foundColumn.typeLabel === 'Ophaaladres') {
                        address = order.addresses.find((address) => address.type === 'pickup' && collo?.pickupAddressIndex === address.index) || {}
                    }

                    if (foundColumn.typeLabel === 'Bezorgadres') {
                        address = order.addresses.find((address) => address.type === 'delivery' && collo?.deliveryAddressIndex === address.index) || {}
                    }

                    // @ts-ignore
                    return typeof foundColumn.get === 'function' ? foundColumn.get({reseller, collo, order, address, customers}) : foundColumn.get
                } else {
                    return collo[foundColumn.value]
                }
            })
        }
    }

    await pushInChunks(csvContent, rows, getLine, onProgress)

    return csvContent
}

async function packagesToCSV(packages, customers, onProgress) {
    const csvContent = [['id', 'Klant', 'Type', 'Barcode', 'Status', 'Adres', 'Datum aangemeld', 'Datum opgehaald', 'Datum op hub', 'Datum bezorgd', 'Datum retour opgehaald', 'Datum retour op hub', 'Datum retour bezorgd']]

    await pushInChunks(csvContent, packages, (packaging) => {
        const customer = customers[packaging.customerId]

        const registeredTimestamp = packaging.events[0].timestamp
        const collectedTimestamp = packaging.events.find((event) => event.status === 'collected')?.timestamp
        const atHubTimestamp = packaging.events.find((event) => event.status === 'athub')?.timestamp
        const deliveredTimestamp = packaging.events.find((event) => event.status === 'delivered')?.timestamp
        const returnCollectedTimestamp = packaging.events.find((event) => event.status === 'return_collected')?.timestamp
        const returnAtHubTimestamp = packaging.events.find((event) => event.status === 'return_athub')?.timestamp
        const returnDeliveredTimestamp = packaging.events.find((event) => event.status === 'return_delivered')?.timestamp

        const line = []
        line.push(packaging._id)
        line.push(customer?.name || packaging.customerId)
        line.push(packaging.type)
        line.push(packaging.barcode)
        line.push(dbCodes.packagingStatus[packaging.status])
        line.push(packaging.address ? `${packaging.address.street} ${packaging.address.nr}${packaging.address.addition} ${packaging.address.postalCode} ${packaging.address.city}` : '')

        line.push(registeredTimestamp ? moment(registeredTimestamp).format('DD-MM-YYYY') : '')
        line.push(collectedTimestamp ? moment(collectedTimestamp).format('DD-MM-YYYY') : '')
        line.push(atHubTimestamp ? moment(atHubTimestamp).format('DD-MM-YYYY') : '')
        line.push(deliveredTimestamp ? moment(deliveredTimestamp).format('DD-MM-YYYY') : '')
        line.push(returnCollectedTimestamp ? moment(returnCollectedTimestamp).format('DD-MM-YYYY') : '')
        line.push(returnAtHubTimestamp ? moment(returnAtHubTimestamp).format('DD-MM-YYYY') : '')
        line.push(returnDeliveredTimestamp ? moment(returnDeliveredTimestamp).format('DD-MM-YYYY') : '')

        return line
    }, onProgress)

    return csvContent
}

async function parcelsToCSV(isCustomer, parcels, reseller, customers, carriers, onProgress) {
    let csvContent = [['_id', 'Datum', 'Debiteurnummer', 'Klant', 'Contactpersoon', 'Naam', 'T.a.v.', 'Straat', 'Nr', 'Toevoeging', '2e adres regel', 'Postcode', 'Plaats', 'Land', 'Emailadres T&T', 'Referentie', 'Bezorginstructie', 'Opties', 'Toeslagen', 'Prijs', 'Productcodes', 'Vervoerder', 'Platform', 'Crediteurnummer', 'Track & Trace', 'Track & Trace Link', 'Bezorgdatum', 'Status', 'Gewicht', 'Lengte', 'Breedte', 'Hoogte', 'Gefactureerd']]

    if (isCustomer) {
        csvContent = [['_id', 'Datum', 'Naam', 'T.a.v.', 'Straat', 'Nr', 'Toevoeging', '2e adres regel', 'Postcode', 'Plaats', 'Land', 'Emailadres T&T', 'Referentie', 'Bezorginstructie', 'Opties', 'Toeslagen', 'Prijs', 'Productcodes', 'Vervoerder', 'Track & Trace', 'Track & Trace Link', 'Bezorgdatum', 'Status', 'Gewicht', 'Lengte', 'Breedte', 'Hoogte']]
    }

    const carrierObject = {}
    carriers.map((carrier) => carrierObject[carrier.name] = carrier)

    await pushInChunks(csvContent, parcels, (parcel) => {
        const line = []

        let price = parcel.price

        parcel.fees.map((fee) => {
            if (typeof fee.price === 'string' && fee.price) {
                price = formatPrice(parsePrice(price) + (parsePrice(fee.price) * fee.quantity))
            }
        })

        if (parcel.price === 'priceScale') {
            price = `€ ${parcel.priceScaleRange.min} - € ${parcel.priceScaleRange.max}`
        } else {
            price = `€ ${price}`
        }

        const fees = parcel.fees.map((fee) => {
            if (fee.quantity === 1) {
                return fee.description
            } else {
                return `${fee.quantity}x ${fee.description}`
            }
        })

        const productCodes = parcel.productCodes.map((item) => {
            if (item.quantity === 1) {
                return item.productCode
            } else {
                return `${item.quantity}x ${item.productCode}`
            }
        })

        parcel.fees.map((fee) => {
            if (fee.productCode) {
                if (fee.quantity === 1) {
                    productCodes.push(fee.productCode)
                } else {
                    productCodes.push(`${fee.quantity}x ${fee.productCode}`)
                }
            }
        })

        const deliveryHistory = _.find(parcel.history, (entry) => entry.status === dbCodes.parcelStatus.bezorgd())
        let deliveryDate = ''

        if (deliveryHistory) {
            deliveryDate = deliveryHistory.eventTime || deliveryHistory.timestamp
        }

        line.push(parcel._id)
        line.push(moment(parcel.date).format('DD-MM-YYYY'))
        if (!isCustomer) {
            const customer = customers[parcel.customer]
            line.push(customer ? customer.debtorCode : '')
            line.push(customer ? customer.name : '')
            line.push(parcel.contact)
        }
        line.push(parcel.address.name)
        line.push(parcel.address.attention)
        line.push(parcel.address.street)
        line.push(parcel.address.nr)
        line.push(parcel.address.addition)
        line.push(parcel.address.street2)
        line.push(parcel.address.postalCode)
        line.push(parcel.address.city)
        line.push(parcel.address.country)
        line.push(parcel.emailTT || parcel.address.email || '')
        line.push(parcel.reference)
        line.push(parcel.comment)
        line.push(parcel.options.length > 0 ? parcel.options.join(', ') : '')
        line.push(fees.length > 0 ? fees.join(', ') : '')
        line.push(price)
        line.push(productCodes.length > 0 ? productCodes.join(', ') : '')
        line.push(carrierObject[parcel.carrier]?.displayName || parcel.carrier.split('-')[0])

        if (!isCustomer) {
            line.push(carrierObject[parcel.carrier]?.platform || '')
            line.push(reseller.settings.parcels.carriers[parcel.carrier]?.creditorCode || '')
        }

        line.push(parcel.trackTrace)
        line.push(parcel.trackTraceLink)
        line.push(deliveryDate)
        line.push(dbCodes.parcelStatus[parcel.status])
        line.push(parcel.weight)
        line.push(parcel.length || 0)
        line.push(parcel.width || 0)
        line.push(parcel.height || 0)
        if (!isCustomer) {
            line.push(parcel.invoiced ? 'Ja' : 'Nee')
        }

        return line
    }, onProgress)

    return csvContent
}

async function customersToCSV(customers, onProgress) {
    const csvContent = [['_id', 'Debiteurnummer', 'Naam', 'Straat', 'Huisnummer', 'Toevoeging', '2e adres regel', 'Postcode', 'Plaats', 'Land', 'Telefoon', 'Emailadres', 'Contactpersonen', 'Emailadres klantlogin', 'Tarieftabel Nederland', 'Tarieftabel Buitenland', 'Laatste factuur', 'Laatst actief', 'Prijs ophaalrit', 'Webshop koppelingen']]

    await pushInChunks(csvContent, customers, (customer) => {
        const line = []

        const contacts = customer.contacts.map((contact) => {
            return `${contact.name} ${contact.phone} ${contact.email}`
        }).join(', ')
        line.push(customer._id)
        line.push(customer.debtorCode || '')
        line.push(customer.name)
        line.push(customer.address.street)
        line.push(customer.address.nr)
        line.push(customer.address.addition)
        line.push(customer.address.street2)
        line.push(customer.address.postalCode)
        line.push(customer.address.city)
        line.push(customer.address.country)
        line.push(customer.phone)
        line.push(customer.email)
        line.push(contacts)
        line.push(customer.loginEmail || '')
        line.push(customer.settings.parcels.priceTable || 'Standaard')
        line.push(customer.settings.parcels.priceTableAbroad || customer.settings.parcels.priceTable || 'Standaard')
        line.push(customer.lastInvoice ? moment(customer.lastInvoice).format('DD-MM-YYYY') : '')
        line.push(customer.lastActive ? moment(customer.lastActive).format('DD-MM-YYYY HH:mm') : '')
        line.push(customer.settings.parcels.autoPickupOrder && customer.settings.parcels.autoPickupPrice ? `€ ${customer.settings.parcels.autoPickupPrice}` : '')
        let connections = []

        Object.keys(customer.settings.webshops).map((webshop) => {
            if (customer.settings.webshops[webshop]?.active) {
                connections.push(webshopKeyToName[webshop] || webshop)
            }
        })

        line.push(connections.sort().join(', '))

        return line
    }, onProgress)

    return csvContent
}

async function subscriptionsToCSV(subscriptions, customers, onProgress) {
    const csvContent = [['Debiteurnummer', 'Klant', 'Omschrijving', 'Prijs', 'Termijn', 'Eerste factuurdatum', 'Begindatum', 'Einddatum', 'Opmerkingen']]

    await pushInChunks(csvContent, subscriptions, (subscription) => {
        const customer = customers[subscription.customer]
        const line = []

        line.push(customer ? customer.debtorCode : '')
        line.push(customer ? customer.name : '')
        line.push(subscription.description)
        line.push(`€ ${subscription.price}`)
        line.push(RRule.fromString(subscription.rrule).toText((t) => {
            return languages.DUTCH.rrule[t] || t
        }, languages.DUTCH))
        line.push(moment(RRule.fromString(subscription.rrule).options.dtstart).format('DD-MM-YYYY'))
        line.push(moment(subscription.startDate).format('DD-MM-YYYY'))
        line.push(subscription.endDate === '2999-12-31' ? '-' : moment(subscription.endDate).format('DD-MM-YYYY'))
        line.push(subscription.notes)

        return line
    }, onProgress)

    return csvContent
}

async function invoicesToCSVTemplate(invoices, customers, template, onProgress) {
    const columns = getColumnsInvoiceExport(template.method)
    const foundColumns = template.columns.map((column) => columns.find((c) => c.value === column))

    const csvContent = [[]]
    foundColumns.forEach((foundColumn) => {
        const label = `${foundColumn?.typeLabel}: ${foundColumn?.label}`

        csvContent[0].push(label)
    })

    if (template.method === 'invoice') {
        await pushInChunks(csvContent, invoices, (invoice) => {
            const line = []

            foundColumns.forEach((foundColumn) => {
                if (!foundColumn) {
                    line.push('')
                } else if (foundColumn.get) {
                    // @ts-ignore
                    line.push(typeof foundColumn.get === 'function' ? foundColumn.get({invoice, customers}) : foundColumn.get)
                } else {
                    line.push(invoice[foundColumn.value])
                }
            })

            return line
        }, onProgress)
    }

    if (template.method === 'invoiceLine') {
        const invoiceLines = invoices.flatMap((invoice) => {
            return invoice.invoiceLines.map((invoiceLine) => ({
                invoice,
                invoiceLine
            }))
        })

        await pushInChunks(csvContent, invoiceLines, ({invoice, invoiceLine}) => {
            const line = []

            foundColumns.forEach((foundColumn) => {
                if (!foundColumn) {
                    line.push('')
                } else if (foundColumn.get) {
                    let thisInvoiceLine = structuredClone(invoiceLine)

                    // @ts-ignore
                    line.push(typeof foundColumn.get === 'function' ? foundColumn.get({invoiceLine: thisInvoiceLine, invoice, customers}) : foundColumn.get)
                } else {
                    line.push(invoice[foundColumn.value])
                }
            })

            return line
        }, onProgress)
    }

    return csvContent
}

async function shiftsToCSV(shifts, reseller, customers, users, onProgress) {
    const csvContent = [[
        Languages.date['NL'],
        Languages.name['NL'],
        Languages.customer['NL'],
        Languages.messenger['NL'],
        Languages.startTime['NL'],
        Languages.startTimeExecuted['NL'],
        Languages.endTime['NL'],
        Languages.endTimeExecuted['NL'],
        Languages.startLocation['NL'],
        Languages.endLocation['NL'],
        Languages.instructions['NL'],
        Languages.status['NL'],
        Languages.target['NL'],
        Languages.targetExecuted['NL'],
        Languages.workedTime['NL'],
        Languages.pausedTime['NL'],
        Languages.price['NL']
    ]]

    reseller.settings.shifts.activities?.map((activity) => {
        csvContent[0].push(activity.name)
    })

    await pushInChunks(csvContent, shifts, (shift) => {
        const line = []

        line.push(moment(shift.date).format('DD-MM-YYYY'))
        line.push(shift.name)
        line.push(customers[shift.customerId]?.name || '')
        line.push(users[shift.messengerId]?.name || '')
        line.push(shift.plannedStartTime)
        line.push(shift.startTime ? moment(shift.startTime).format('HH:mm') : '')
        line.push(shift.plannedEndTime)
        line.push(shift.endTime ? moment(shift.endTime).format('HH:mm') : '')
        const startPoint = shift.startPoint ? `${shift.startPoint.street} ${shift.startPoint.nr}${shift.startPoint.addition} ${shift.startPoint.postalCode} ${shift.startPoint.city}` : ''
        const endPoint = shift.endPoint ? `${shift.endPoint.street} ${shift.endPoint.nr}${shift.endPoint.addition} ${shift.endPoint.postalCode} ${shift.endPoint.city}` : ''
        line.push(startPoint)
        line.push(endPoint)
        line.push(shift.instructions)
        line.push(Colors.shiftStatus(reseller, shift).status)
        line.push(shift.targets?.[0]?.value || '')
        line.push(shift.targets?.[0]?.realized || '')
        line.push(shift.endTime ? formatDuration(shift.workedTime) : '')
        line.push(formatDuration((shift.pausedTime || 0)))
        line.push(shift.price || '')

        reseller.settings.shifts.activities?.map((activity) => {
            line.push(shift.activities[activity.id]?.duration ? formatDuration(shift.activities[activity.id].duration) : '')
        })

        return line
    }, onProgress)

    return csvContent
}

async function usersToCSV(users, onProgress) {
    const csvContent = [['Naam', 'Emailadres', 'Telefoon']]

    await pushInChunks(csvContent, users, (user) => {
        const line = []
        line.push(user.name)
        line.push(user.email)
        line.push(user.phone)

        return line
    }, onProgress)

    return csvContent
}

async function paychecksToCSV(paychecks, onProgress) {
    const csvContent = [['Naam', 'Dagen', 'Uren', 'Salaris', 'Onbelast']]
    await pushInChunks(csvContent, paychecks, (paycheck) => {
        const line = []
        const name = paycheck.firstName && paycheck.lastName ? `${paycheck.lastName}, ${paycheck.firstName}` : paycheck.messenger
        line.push(name)
        line.push(paycheck.days)
        line.push(paycheck.hours)
        line.push(paycheck.salary)
        line.push(paycheck.taxFree)

        return line
    }, onProgress)

    return csvContent
}

async function addressesToCSV(addresses, onProgress, withTimeslot) {
    const csvContent = [[
        Languages.name['NL'],
        Languages.street['NL'],
        Languages.houseNumber['NL'],
        Languages.addition['NL'],
        Languages.street2['NL'],
        Languages.postalCode['NL'],
        Languages.city['NL'],
        Languages.country['NL'],
        Languages.phone['NL'],
        Languages.emailAddress['NL'],
        Languages.instructions['NL'],
        ...(withTimeslot ? [Languages.startTime['NL'], Languages.endTime['NL']] : [])
    ]]

    await pushInChunks(csvContent, addresses, (address) => {
        const line = []

        line.push(address.name)
        line.push(address.street)
        line.push(address.nr)
        line.push(address.addition)
        line.push(address.street2)
        line.push(address.postalCode)
        line.push(address.city)
        line.push(address.country)
        line.push(address.phone)
        line.push(address.email)
        line.push(address.instructions)

        if (withTimeslot) {
            line.push(address.startTime || '')
            line.push(address.endTime || '')
        }

        return line
    }, onProgress)

    return csvContent
}

// The columns of the template in its order, a column that no longer exists (the branch) stays empty
async function routesToCSV(rows, withBranch, template, onProgress) {
    const columns = getRouteExportColumns(withBranch)
    const foundColumns = template.columns.map((value) => columns.find((column) => column.value === value))
    const csvContent = [foundColumns.map((column) => column?.label || '')]

    await pushInChunks(csvContent, rows, (row) => foundColumns.map((column) => column ? column.get(row) : ''), onProgress)

    return csvContent
}

function priceTableToCSV(priceTable) {
    const csvContent = []
    const table = []

    _.keys(priceTable.table).map((zone1, i) => {
        _.keys(priceTable.table[zone1]).map((zone2, j) => {
            table[j] = table[j] || []
            table[j + 1] = table[j + 1] || []

            table[0][i + 1] = zone1
            table[j + 1][0] = zone2
            table[j + 1][i + 1] = priceTable.table[zone1][zone2] ? formatPrice(priceTable.table[zone1][zone2]) : '0'
        })
    })

    table.map((row) => {
        csvContent.push(row)
    })

    csvContent.push([])
    csvContent.push([])

    _.keys(priceTable.fees).map((name) => {
        csvContent.push(['', '', name, formatPrice(priceTable.fees[name])])
    })

    return csvContent
}

function download(name, content) {
    // utf-8 BOM to display € correctly - https://stackoverflow.com/questions/56154046/downloading-blob-with-type-text-csv-strips-unicode-bom
    const buffer = new ArrayBuffer(3)
    const dataView = new DataView(buffer)
    dataView.setUint8(0, 0xef)
    dataView.setUint8(1, 0xbb)
    dataView.setUint8(2, 0xbf)
    const read = new Uint8Array(buffer)

    return new Promise((resolve, reject) => {
        stringify(content, {delimiter: ';'}, (err, output) => {
            if (err) {
                reject(err)
                return
            }

            // @ts-ignore
            const blob = new Blob([read, output], {type: 'data:text/csv,charset=utf-8'})
            FileSaver.saveAs(blob, name)
            resolve()
        })
    })
}

export default {
    orders: async (reseller, orders, startDate, endDate, customers, routes, vehicles, template, onProgress) => {
        const name = template?.name ? `${template.name}_${startDate}_${endDate}.csv` : `Ritten_${startDate}_${endDate}.csv`
        const content = template ? await ordersToCSVTemplate(reseller, orders, customers, routes, vehicles, template, onProgress) : ordersToCSV(reseller, orders, customers)
        return download(name, content)
    },

    packages: async (packages, customers, onProgress) => {
        const name = 'Emabllage.csv'
        const content = await packagesToCSV(packages, customers, onProgress)
        return download(name, content)
    },

    parcels: async (isCustomer, parcels, startDate, endDate, reseller, customers, carriers, onProgress) => {
        const name = `Zendingen_${startDate}_${endDate}.csv`
        const content = await parcelsToCSV(isCustomer, parcels, reseller, customers, carriers, onProgress)
        return download(name, content)
    },

    subscriptions: async (subscriptions, customers, onProgress) => {
        const name = 'Abonnementen.csv'
        const content = await subscriptionsToCSV(subscriptions, customers, onProgress)
        return download(name, content)
    },

    invoices: async (invoices, startDate, endDate, customers, template, onProgress) => {
        const name = template?.name ? `${template.name}_${startDate}_${endDate}.csv` : `Facturen_${startDate}_${endDate}.csv`
        const content = await invoicesToCSVTemplate(invoices, customers, template, onProgress)
        return download(name, content)
    },

    paychecks: async (paychecks, startDate, endDate, onProgress) => {
        const name = `Urenregistratie_${startDate}_${endDate}.csv`
        const content = await paychecksToCSV(paychecks, onProgress)
        return download(name, content)
    },

    shifts: async (shifts, startDate, endDate, reseller, customers, users, onProgress) => {
        const name = `Diensten_${startDate}_${endDate}.csv`
        const content = await shiftsToCSV(shifts, reseller, customers, users, onProgress)
        return download(name, content)
    },

    customers: async (customers, onProgress) => {
        const name = 'Klanten.csv'
        const content = await customersToCSV(customers, onProgress)
        return download(name, content)
    },

    addresses: async (addresses, onProgress, withTimeslot = false) => {
        const name = 'Adresboek.csv'
        const content = await addressesToCSV(addresses, onProgress, withTimeslot)
        return download(name, content)
    },

    users: async (users, onProgress) => {
        const name = 'Gebruikers.csv'
        const content = await usersToCSV(users, onProgress)
        return download(name, content)
    },

    // rows: the RouteRows of the Routes table (getRouteRow)
    // template: the default export or one of reseller.settings.routes.exportCsvTemplates
    routes: async (rows, startDate, endDate, withBranch, template, onProgress) => {
        const name = template?.id ? `${template.name}_${startDate}_${endDate}.csv` : `Routes_${startDate}_${endDate}.csv`
        const content = await routesToCSV(rows, withBranch, template, onProgress)
        return download(name, content)
    },

    priceTable: (name, priceTable) => {
        name = `Tarieftabel_${name}.csv`
        const content = priceTableToCSV(priceTable)
        return download(name, content)
    }
}

export const getColumns = (type, reseller) => {
    /**
     * @type {{[key in 'order' | 'address' | 'collo']: {value: string, label: string, get: (args: {order?: ExportOrder, customers?: Customer[], reseller?: Reseller, address?: OrderAddress, routes?: Route[], vehicles?: Vehicle[], collo?: Collo}) => any}[]}}
     */
    const legacyColliTypeColumnMap = {
        'box': 'order.typeBox',
        'crate': 'order.typeCrate',
        'envelope': 'order.typeEnvelope',
        'pallet': 'order.typePallet',
        'roll container': 'order.typeRollContainer',
        'other': 'order.typeOther'
    }

    const resellerColliTypeColumns = (reseller?.settings?.orders?.colliTypes || []).map((colliType) => ({
        value: `order.type.${colliType.id}`,
        label: `Aantal ${String(colliType.name || '').toLowerCase()}`,
        get: ({order, reseller}) => countColliByType(order, reseller, colliType.id)
    }))

    const legacyOrderColliTypeColumns = Object.entries(legacyColliTypeColumnMap).map(([colliTypeId, value]) => ({
        value,
        label: `Aantal ${dbCodes.colloTypes[colliTypeId].toLowerCase()}`,
        get: ({order, reseller}) => countColliByType(order, reseller, colliTypeId)
    }))

    const orderColliTypeColumns = [...resellerColliTypeColumns, ...legacyOrderColliTypeColumns]
    const columns = {
        order: [
            {
                value: 'order._id',
                label: 'Id',
                get: ({order}) => order._id
            },
            {
                value: 'order.date',
                label: 'Datum',
                get: ({order}) => order.date
            },
            {
                value: 'order.customerDebtorCode',
                label: 'Debiteurnummer',
                get: ({order, customers}) => customers[order.customer]?.debtorCode || ''
            },
            {
                value: 'order.customer',
                label: 'Klant',
                get: ({order, customers}) => customers[order.customer]?.name || ''

            },
            {
                value: 'order.sender',
                label: 'Afzender',
                get: ({order}) => order.senderAddress?.name || ''
            },
            {
                value: 'order.contact',
                label: 'Contact',
                get: ({order}) => order?.contact || ''
            },
            {
                value: 'order.email',
                label: 'Emailadres',
                get: ({order}) => order.email
            },
            {
                value: 'order.phone',
                label: 'Telefoon',
                get: ({order}) => order.phone
            },
            {
                value: 'order.price',
                label: 'Prijs',
                get: ({order}) => order.price === 'priceScale' ? '' : `€ ${order?.price?.replace(',', '.')}`
            },
            {
                value: 'order.fees',
                label: 'Toeslagen',
                get: ({order, reseller}) => getOrderFeesText(order, reseller)
            },
            {
                value: 'order.invoiced',
                label: 'Gefactureerd',
                get: ({order}) => order.invoiced ? Languages.yes['NL'] : Languages.no['NL']
            },
            {
                value: 'order.reference',
                label: 'Referentie',
                get: ({order}) => order?.reference || ''
            },
            {
                value: 'order.trackTrace',
                label: 'Track & Trace code',
                get: ({order}) => order?.trackTrace || ''
            },
            {
                value: 'order.trackTraceLink',
                label: 'Track & Trace link',
                get: ({order, reseller}) => {
                    const domain = reseller?.customBrandingEnabled && reseller?.settings.domain ? reseller.settings.domain : process.env.NODE_ENV === 'production' ? 'app.veloyd.nl' : 'test.veloyd.nl'

                    return `https://${domain}/track&trace/${order.trackTrace}`
                }
            },
            {
                value: 'order.status',
                label: 'Status',
                get: ({order}) => dbCodes.status[order?.status] || ''
            },
            {
                value: 'order.subStatus',
                label: 'Substatus',
                get: ({order}) => Colors.orderStatusColor(order)?.subStatus || ''
            },
            {
                value: 'order.dateCreated',
                label: 'Datum aangemaakt',
                get: ({order}) => {
                    return moment(order.history[0].timestamp).format('DD-MM-YYYY HH:mm:ss')
                }
            },
            {
                value: 'order.dateCreated',
                label: 'Datum aangemaakt (ISO 8601)',
                get: ({order}) => {
                    return moment(order.history[0].timestamp).toISOString(true)
                }
            },
            {
                value: 'order.dateHubScan',
                label: 'Datum aangeleverd',
                get: ({order}) => {
                    let date = ''

                    order.history.forEach((entry) => {
                        if (date) {
                            return
                        }

                        if (entry.colli?.length > 0) {
                            if (entry.colli.some((collo) => collo.status === 'athub')) {
                                date = moment(entry.timestamp).format('YYYY-MM-DD')
                            }
                        }
                    })

                    return date
                }
            },
            {
                value: 'order.completedDate',
                label: 'Datum afgerond',
                get: ({order}) => {
                    let date = ''

                    order.history.forEach((entry) => {
                        if (date) {
                            return
                        }

                        if (entry.status === dbCodes.status.afgerond()) {
                            date = moment(entry.timestamp).format('YYYY-MM-DD')
                        }
                    })

                    return date
                }
            },
            {
                value: 'order.amountOfDaysBetweenHubScanAndCompleted',
                label: 'Aantal dagen tussen aangeleverd en afgerond',
                get: ({order, reseller}) => {
                    const cols = getColumns(type, reseller)
                    const hubscanDate = cols.find((column) => column.value === 'order.dateHubScan').get({order})
                    const completedDate = cols.find((column) => column.value === 'order.completedDate').get({order})

                    if (hubscanDate && completedDate) {
                        return moment(completedDate).diff(hubscanDate, 'days')
                    }

                    return ''
                }
            },
            {
                value: 'order.nrOfAttempts',
                label: 'Aantal pogingen',
                get: ({order}) => order.history.filter((entry) => entry?.type === 'pickup' || entry?.type === 'delivery').length
            },
            {
                value: 'order.route',
                label: 'Route',
                get: ({order}) => order?.routeName || ''
            },
            {
                value: 'order.vehicleId',
                label: 'Voertuig',
                get: ({order, vehicles, routes}) => {
                    const route = routes[order.routeId]
                    const vehicle = vehicles?.find((vehicle) => vehicle._id === route?.vehicleId)
                    return vehicle?.name || ''
                }
            },
            {
                value: 'order.vehicleType',
                label: 'Voertuigsoort',
                get: ({order, routes, reseller}) => {
                    const route = routes[order.routeId]
                    const vehicleType = reseller.settings.vehicleTypes.find((vt) => vt._id === route?.vehicleTypeId)
                    return vehicleType?.name || ''
                }
            },
            {
                value: 'order.vehicleType.hourlyRate',
                label: 'Voertuigsoort uurtarief',
                get: ({order, routes, reseller}) => {
                    const route = routes[order.routeId]
                    const vehicleType = reseller.settings.vehicleTypes.find((vt) => vt._id === route?.vehicleTypeId)
                    return vehicleType?.hourlyRate ? `€${vehicleType.hourlyRate.replace(',', '.')}` : ''
                }
            },
            {
                value: 'order.carrier',
                label: 'Vervoerder',
                get: ({reseller}) => reseller.settings.accountName || reseller.name
            },
            {
                value: 'order.carrierCreditorCode',
                label: 'Crediteurnummer vervoerder',
                get: ({order, reseller}) => {
                    if (order?.handledBy !== 'partner') {
                        return ''
                    }

                    const partnerSettings = reseller.settings.outgoingPartners?.find((settings) => settings._id === order.partnerId)

                    return partnerSettings?.creditorCode || reseller.settings.defaultPartnerSettings?.outgoing?.creditorCode || ''
                }
            },
            {
                value: 'order.messenger',
                label: 'Koerier',
                get: ({order}) => order?.messengerName || ''
            },
            {
                value: 'order.routeDuration',
                label: 'Uitgevoerde routeduur',
                get: ({order, routes}) => {
                    const route = routes[order.routeId]
                    const duration = route?.endTime ? formatDuration(moment(route?.endTime).diff(moment(route?.startTime), 'seconds')) : '-'
                    return duration
                }
            },
            {
                value: 'order.notes',
                label: 'Opmerkingen',
                get: ({order}) => order?.notes || ''
            },
            {
                value: 'order.nrOfColli',
                label: 'Aantal colli',
                get: ({order}) => order?.colli.length
            },
            {
                value: 'order.pickedUpColli',
                label: 'Aantal colli opgehaald',
                get: ({order}) => order?.colli.filter((collo) => typeof collo.pickupAddressIndex === 'number' && !['cancelled', 'pickup', 'outforpickup', 'notcollected'].includes(collo.status)).length
            },
            {
                value: 'order.deliveredColli',
                label: 'Aantal colli bezorgd',
                get: ({order}) => order?.colli.filter((collo) => typeof collo.pickupAddressIndex === 'number' && collo.status === 'delivered').length
            },
            ...orderColliTypeColumns,
            {
                value: 'order.amountOfAddresses',
                label: 'Aantal adressen',
                get: ({order}) => order?.addresses.length
            }

        ],
        address: [
            {
                value: 'address.type',
                label: 'Type',
                get: ({address}) => dbCodes.addressType[address?.type] || ''
            },
            {
                value: 'address.stopNumber',
                label: 'Stopnummer',
                get: ({address}) => address?.stopNumber ?? ''
            },
            {
                value: 'address.name',
                label: 'Naam',
                get: ({address}) => address?.name || ''
            },
            {
                value: 'address.attention',
                label: 'T.a.v.',
                get: ({address}) => address?.attention || ''
            },
            {
                value: 'address.street',
                label: 'Straat',
                get: ({address}) => address?.street || ''
            },
            {
                value: 'address.nr',
                label: 'Huisnummer',
                get: ({address}) => address?.nr || ''
            },
            {
                value: 'address.addition',
                label: 'Huisnummer toevoeging',
                get: ({address}) => address?.addition || ''
            },
            {
                value: 'address.street2',
                label: '2e adres regel',
                get: ({address}) => address?.street2 || ''
            },
            {
                value: 'address.postalCode',
                label: 'Postcode',
                get: ({address}) => address?.postalCode || ''
            },
            {
                value: 'address.city',
                label: 'Plaats',
                get: ({address}) => address?.city || ''
            },
            {
                value: 'address.country',
                label: 'Land',
                get: ({address}) => address?.country || ''
            },
            {
                value: 'address.instructions',
                label: 'Instructies',
                get: ({address}) => address?.instructions || ''
            },
            {
                value: 'address.startTime',
                label: 'Tijdvak starttijd',
                get: ({address}) => address?.startTime || ''
            },
            {
                value: 'address.endTime',
                label: 'Tijdvak eindtijd',
                get: ({address}) => address?.endTime || ''
            },
            {
                value: 'address.email',
                label: 'Emailadres',
                get: ({address}) => address?.email || ''
            },
            {
                value: 'address.phone',
                label: 'Telefoon',
                get: ({address}) => address?.phone || ''
            },
            {
                value: 'address.status',
                label: 'Status',
                get: ({address, order}) => {
                    if (!address) {
                        return ''
                    }

                    const status = address[`${address.type}Status`] || convertStatus[`addressTo${address.type === 'delivery' ? 'Delivery' : 'Pickup'}Status`](order, address)

                    return status ? dbCodes[`${address.type}Status`][status] : ''
                }
            },
            {
                value: 'address.signee',
                label: 'Naam ontvanger',
                get: ({address, order}) => {
                    if (!address) {
                        return ''
                    }

                    const reversedHistory = order && [...order.history].reverse()

                    return reversedHistory?.find((entry) => entry.type === address.type && entry.addressIndex === address.index)?.signee || ''
                }
            },
            {
                value: 'address.comment',
                label: 'Opmerking koerier',
                get: ({address, order}) => {
                    if (!address) {
                        return ''
                    }
                    const reversedHistory = order?.history.reverse()

                    return reversedHistory?.find((entry) => entry.type === address.type && entry.addressIndex === address.index)?.comment || ''
                }
            },
            {
                value: 'address.options',
                label: 'Opties',
                get: ({address, reseller}) => {
                    if (!address) {
                        return ''
                    }

                    let options = []

                    if (address.gpsRequired) {
                        options.push('GPS verplicht')
                    }

                    if (address.scanRequired) {
                        options.push('Scan verplicht')
                    }

                    if (address.imageRequired) {
                        options.push('Foto verplicht')
                    }

                    if (address.signatureRequired) {
                        options.push('Handtekening')
                    }

                    if (address.nameRequired && !address.signatureRequired) {
                        options.push('Naam verplicht')
                    }

                    if (address.signatureNeighbors) {
                        options.push('Handtekening buren')
                    }

                    if (address.statedAddressOnly) {
                        options.push('Niet bij buren')
                    }

                    if (address.mailboxDelivery) {
                        options.push('Brievenbuspakket')
                    }

                    if (address.refrigerated) {
                        options.push('Gekoeld')
                    }

                    if (address.minimumAge) {
                        options.push(`Leeftijdscheck ${address.minimumAge}+`)
                    }

                    if (address.idCheck) {
                        options.push('ID check')
                    }

                    if (address.verificationCode) {
                        options.push('Verificatie code')
                    }

                    if (address.customOptions?.length > 0) {
                        address.customOptions.forEach((optionId) => {
                            const option = reseller.settings.orders.customOptions?.find((option) => option.id === optionId)
                            if (option) {
                                options.push(option.name)
                            }
                        })
                    }

                    options = [...new Set(options)]

                    return options?.length > 0 ? options?.join(', ') : ''
                }
            },
            {
                value: 'address.eta',
                label: 'Geplande ETA',
                get: ({address}) => address?.plannedTimeOfArrival || ''
            },
            {
                value: 'address.etaUtc',
                label: 'Geplande ETA (ISO 8601)',
                get: ({address, order}) => address?.plannedTimeOfArrival ? moment(`${order.date} ${address.plannedTimeOfArrival}`).toISOString(true) : ''
            },
            {
                value: 'address.estimatedTimeOfArrival',
                label: 'Laatst berekende ETA',
                get: ({address}) => address?.estimatedTimeOfArrival || ''
            },
            {
                value: 'address.estimatedTimeOfArrivalUtc',
                label: 'Laatst berekende ETA (ISO 8601)',
                get: ({address, order}) => address?.estimatedTimeOfArrival ? moment(`${order.date} ${address.estimatedTimeOfArrival}`).toISOString(true) : ''
            },
            {
                value: 'address.pickupAt',
                label: 'Aankomsttijd',
                get: ({address}) => address?.timeOfArrival || ''
            },
            {
                value: 'address.pickupAtUtc',
                label: 'Aankomsttijd (ISO 8601)',
                get: ({address, order}) => address?.timeOfArrival ? moment(`${order.date} ${address.timeOfArrival}`).toISOString(true) : ''
            },
            {
                value: 'address.delayETA',
                label: 'Afwijking ETA (min)',
                get: ({address, order}) => address?.timeOfArrival && address?.plannedTimeOfArrival ? moment(`${order.date} ${address.timeOfArrival}`).diff(moment(`${order.date} ${address.plannedTimeOfArrival}`), 'minute') : ''
            },
            {
                value: 'address.amountOfTries',
                label: 'Aantal pogingen',
                get: ({address, order}) => {
                    if (!address) {
                        return ''
                    }

                    return order.history.filter((entry) => entry.type === address.type && entry.addressIndex === address.index).length
                }
            }
        ],
        collo: [
            {
                value: 'collo.barcode',
                label: 'Barcode',
                get: ({collo}) => collo.barcode || ''
            },
            {
                value: 'collo.type',
                label: 'Type',
                get: ({collo, reseller}) => getColliTypeName(collo.type, reseller)
            },
            {
                value: 'collo.description',
                label: 'Omschrijving',
                get: ({collo}) => collo.description || ''
            },
            {
                value: 'collo.weight',
                label: 'Gewicht (g)',
                get: ({collo}) => collo.weight || ''
            },
            {
                value: 'collo.length',
                label: 'Lengte (mm)',
                get: ({collo}) => collo.length || ''
            },
            {
                value: 'collo.width',
                label: 'Breedte (mm)',
                get: ({collo}) => collo.width || ''
            },
            {
                value: 'collo.height',
                label: 'Hoogte (mm)',
                get: ({collo}) => collo.height || ''
            },
            {
                value: 'collo.status',
                label: 'Status',
                get: ({collo}) => dbCodes.colloStatus[collo.status]
            },
            {
                value: 'collo.reason',
                label: 'Status reden',
                get: ({collo}) => Colors.colloStatusColor('', collo).reason // use colloStatusColor to add nrNeighbours and deliveredInMailbox
            },
            {
                value: 'collo.pickupAt',
                label: 'Datum opgehaald',
                get: ({collo, order}) => {
                    if (typeof collo.pickupAddressIndex === 'number') {
                        const entry = [...order.history].reverse().find((entry) => entry.type === 'pickup' && entry.addressIndex === collo.pickupAddressIndex && entry.colli.find((c) => c.index === collo.index && ['collected', 'athub'].includes(c.status)))

                        if (entry) {
                            return moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss')
                        }

                        return ''
                    }
                }
            },
            {
                value: 'collo.pickupAtUtc',
                label: 'Datum opgehaald (ISO 8601)',
                get: ({collo, order}) => {
                    if (typeof collo.pickupAddressIndex === 'number') {
                        const entry = [...order.history].reverse().find((entry) => entry.type === 'pickup' && entry.addressIndex === collo.pickupAddressIndex && entry.colli.find((c) => c.index === collo.index && ['collected', 'athub'].includes(c.status)))

                        if (entry) {
                            return moment(entry.timestamp).toISOString(true)
                        }

                        return ''
                    }
                }
            },
            {
                value: 'collo.deliveredAt',
                label: 'Datum bezorgd',
                get: ({collo, order}) => {
                    if (typeof collo.deliveryAddressIndex === 'number') {
                        const entry = [...order.history].reverse().find((entry) => entry.type === 'delivery' && entry.addressIndex === collo.deliveryAddressIndex && entry.colli.find((c) => c.index === collo.index && c.status === 'delivered'))

                        if (entry) {
                            return moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss')
                        }

                        return ''
                    }
                }
            },
            {
                value: 'collo.deliveredAtUtc',
                label: 'Datum bezorgd (ISO 8601)',
                get: ({collo, order}) => {
                    if (typeof collo.deliveryAddressIndex === 'number') {
                        const entry = [...order.history].reverse().find((entry) => entry.type === 'delivery' && entry.addressIndex === collo.deliveryAddressIndex && entry.colli.find((c) => c.index === collo.index && c.status === 'delivered'))

                        if (entry) {
                            return moment(entry.timestamp).toISOString(true)
                        }

                        return ''
                    }
                }
            },
            {
                value: 'collo.firstDeliveryAttemptDate',
                label: 'Datum eerste bezorgpoging',
                get: ({collo, order}) => {
                    if (typeof collo.deliveryAddressIndex === 'number') {
                        const entry = order.history.find((entry) => entry.type === 'delivery' && entry.addressIndex === collo.deliveryAddressIndex && entry.colli.find((c) => c.index === collo.index && (['delivered', 'refused'].includes(c?.status) || (c.status === 'notdelivered' && ['nothome', 'wrongaddress', 'companyaddressclosed', 'verificationfailed'].includes(c.reason)))))

                        if (entry) {
                            return moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss')
                        }

                        return ''
                    }
                }
            },
            {
                value: 'collo.firstDeliveryAttemptDateISO',
                label: 'Datum eerste bezorgpoging (ISO 8601)',
                get: ({collo, order}) => {
                    if (typeof collo.deliveryAddressIndex === 'number') {
                        const entry = order.history.find((entry) => entry.type === 'delivery' && entry.addressIndex === collo.deliveryAddressIndex && entry.colli.find((c) => c.index === collo.index && (['delivered', 'refused'].includes(c?.status) || (c.status === 'notdelivered' && ['nothome', 'wrongaddress', 'companyaddressclosed', 'verificationfailed'].includes(c.reason)))))

                        if (entry) {
                            return moment(entry.timestamp).toISOString(true)
                        }

                        return ''
                    }
                }
            },
            {
                value: 'collo.lastDeliveryAttemptDate',
                label: 'Datum laatste bezorgpoging',
                get: ({collo, order}) => {
                    if (typeof collo.deliveryAddressIndex === 'number') {
                        const entry = [...order.history].reverse().find((entry) => entry.type === 'delivery' && entry.addressIndex === collo.deliveryAddressIndex && entry.colli.find((c) => c.index === collo.index && (['delivered', 'refused'].includes(c?.status) || (c.status === 'notdelivered' && ['nothome', 'wrongaddress', 'companyaddressclosed', 'verificationfailed'].includes(c.reason)))))

                        if (entry) {
                            return moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss')
                        }

                        return ''
                    }
                }
            },
            {
                value: 'collo.lastDeliveryAttemptDateISO',
                label: 'Datum laatste bezorgpoging (ISO 8601)',
                get: ({collo, order}) => {
                    if (typeof collo.deliveryAddressIndex === 'number') {
                        const entry = [...order.history].reverse().find((entry) => entry.type === 'delivery' && entry.addressIndex === collo.deliveryAddressIndex && entry.colli.find((c) => c.index === collo.index && (['delivered', 'refused'].includes(c?.status) || (c.status === 'notdelivered' && ['nothome', 'wrongaddress', 'companyaddressclosed', 'verificationfailed'].includes(c.reason)))))

                        if (entry) {
                            return moment(entry.timestamp).toISOString(true)
                        }

                        return ''
                    }
                }
            },
            {
                value: 'collo.firstHubScan',
                label: 'Datum eerste hubscan',
                get: ({collo, order}) => {
                    const entry = order.history.find((entry) => entry.type === 'scan' && entry.colli?.some((c) => c.barcode === collo.barcode))

                    if (entry) {
                        return moment(entry.timestamp).format('DD-MM-YYYY HH:mm')
                    }

                    return ''
                }
            },
            {
                value: 'collo.firstHubScanISO',
                label: 'Datum eerste hubscan (ISO 8601)',
                get: ({collo, order}) => {
                    const entry = order.history.find((entry) => entry.type === 'scan' && entry.colli?.some((c) => c.barcode === collo.barcode))

                    if (entry) {
                        return moment(entry.timestamp).toISOString(true)
                    }

                    return ''
                }
            },
            {
                value: 'collo.lastHubScan',
                label: 'Datum laatste hubscan',
                get: ({collo, order}) => {
                    const entry = [...order.history].reverse().find((entry) => entry.type === 'scan' && entry.colli?.some((c) => c.barcode === collo.barcode))

                    if (entry) {
                        return moment(entry.timestamp).format('DD-MM-YYYY HH:mm')
                    }

                    return ''
                }
            },
            {
                value: 'collo.lastHubScanISO',
                label: 'Datum laatste hubscan (ISO 8601)',
                get: ({collo, order}) => {
                    const entry = [...order.history].reverse().find((entry) => entry.type === 'scan' && entry.colli?.some((c) => c.barcode === collo.barcode))

                    if (entry) {
                        return moment(entry.timestamp).toISOString(true)
                    }

                    return ''
                }
            }
        ]
    }

    if (type === 'order') {
        const startInfo = 'Bij export per rit is dit'
        return [
            ...columns.order.map((column) => ({...column, typeLabel: 'Rit', typeColor: Colors.successBright})),
            ...columns.address.map((column) => ({...column, value: `pickup${column.value}`, typeLabel: 'Ophaaladres', typeColor: Colors.pickup, info: `${startInfo} het eerste ophaaladres`})),
            ...columns.address.map((column) => ({...column, value: `delivery${column.value}`, typeLabel: 'Bezorgadres', typeColor: Colors.delivery, info: `${startInfo} het eerste bezorgadres`})),
            // ...columns.address.map((column) => ({...column, typeLabel: 'Eerste adres', typeColor: Colors.pickupDelivery})),
            ...columns.address.map((column) => ({...column, typeLabel: 'Adres', typeColor: Colors.pickupDelivery, info: `${startInfo} het eerste adres`})),
            // ...columns.collo.map((column) => ({...column, typeLabel: 'Eerste collo', typeColor: Colors.warningBright})),
            ...columns.collo.map((column) => ({...column, typeLabel: 'Collo', typeColor: Colors.warningBright, info: `${startInfo} de eerste collo`}))
        ]
    }

    if (type === 'address') {
        const startInfo = 'Bij export per adres is dit'
        return [
            ...columns.order.map((column) => ({...column, typeLabel: 'Rit', typeColor: Colors.successBright})),
            ...columns.address.map((column) => ({...column, value: `pickup${column.value}`, typeLabel: 'Ophaaladres', typeColor: Colors.pickup})),
            ...columns.address.map((column) => ({...column, value: `delivery${column.value}`, typeLabel: 'Bezorgadres', typeColor: Colors.delivery})),
            ...columns.address.map((column) => ({...column, typeLabel: 'Adres', typeColor: Colors.pickupDelivery})),
            // ...columns.collo.map((column) => ({...column, typeLabel: 'Eerste collo', typeColor: Colors.warningBright})),
            ...columns.collo.map((column) => ({...column, typeLabel: 'Collo', typeColor: Colors.warningBright, info: `${startInfo} de eerste bijbehorende collo`}))
        ]
    }

    if (type === 'collo') {
        const startInfo = 'Bij export per collo is dit'
        return [
            ...columns.order.map((column) => ({...column, typeLabel: 'Rit', typeColor: Colors.successBright})),
            ...columns.address.map((column) => ({...column, value: `pickup${column.value}`, typeLabel: 'Ophaaladres', typeColor: Colors.pickup})),
            ...columns.address.map((column) => ({...column, value: `delivery${column.value}`, typeLabel: 'Bezorgadres', typeColor: Colors.delivery})),
            ...columns.address.map((column) => ({...column, typeLabel: 'Adres', typeColor: Colors.pickupDelivery, info: `${startInfo} het eerste bijbehorende adres`})),
            ...columns.collo.map((column) => ({...column, typeLabel: 'Collo', typeColor: Colors.warningBright}))
        ]
    }
}

export const getColumnsInvoiceExport = (type) => {
    const columns = {
        invoice: [
            {
                value: 'invoice.date',
                label: 'Datum',
                get: ({invoice}) => invoice.date
            },
            {
                value: 'invoice.startDate',
                label: 'Periode startdatum',
                get: ({invoice}) => invoice.startDate
            },
            {
                value: 'invoice.endDate',
                label: 'Periode einddatum',
                get: ({invoice}) => invoice.endDate
            },
            {
                value: 'invoice.invoiceNumber',
                label: 'Factuurnummer',
                get: ({invoice}) => invoice.invoiceNumber || ''
            },
            {
                value: 'invoice.customer',
                label: 'Klant',
                get: ({invoice, customers}) => customers[invoice.customer]?.name || ''

            },
            {
                value: 'invoice.customerDebtorCode',
                label: 'Debiteurnummer',
                get: ({invoice, customers}) => customers[invoice.customer]?.debtorCode || ''
            },
            {
                value: 'invoice.description',
                label: 'Omschrijving',
                get: ({invoice}) => invoice.description || ''
            },
            {
                value: 'invoice.price',
                label: 'Totaal',
                get: ({invoice}) => `€ ${invoice?.price?.replace(',', '.')}`
            },
            {
                value: 'invoice.status',
                label: 'Status',
                get: ({invoice}) => invoice.invoiced ? 'Gefactureerd' : 'Concept'
            },
            {
                value: 'invoice.notes',
                label: 'Notities',
                get: ({invoice}) => invoice.notes || ''
            }
        ],
        invoiceLine: [
            {
                value: 'invoiceLine.date',
                label: 'Datum',
                get: ({invoiceLine}) => invoiceLine.date || ''
            },
            {
                value: 'invoiceLine.reference',
                label: 'Referentie',
                get: ({invoiceLine}) => invoiceLine.reference || ''
            },
            {
                value: 'invoiceLine.description',
                label: 'Omschrijving',
                get: ({invoiceLine}) => invoiceLine.description || ''
            },
            {
                value: 'invoiceLine.quantity',
                label: 'Aantal',
                get: ({invoiceLine}) => invoiceLine.quantity
            },
            {
                value: 'invoiceLine.price',
                label: 'Prijs',
                get: ({invoiceLine}) => `€ ${invoiceLine.price?.replace(',', '.')}`
            },
            {
                value: 'invoiceLine.type',
                label: 'Type',
                get: ({invoiceLine}) => {
                    switch (invoiceLine.type) {
                        case 'order':
                            return 'Rit'
                        case 'parcel':
                            return 'Zending'
                        case 'shift':
                            return 'Dienst'
                        case 'subscription':
                            return 'Abonnement'
                        default:
                            return ''
                    }
                }
            },
            {
                value: 'invoiceLine._id',
                label: 'ID',
                get: ({invoiceLine}) => invoiceLine._id || ''
            }

        ]
    }

    if (type === 'invoice') {
        return [
            ...columns.invoice.map((column) => ({...column, typeLabel: 'Factuur', typeColor: Colors.successBright}))
        ]
    }

    if (type === 'invoiceLine') {
        return [
            ...columns.invoice.map((column) => ({...column, typeLabel: 'Factuur', typeColor: Colors.successBright})),
            ...columns.invoiceLine.map((column) => ({...column, typeLabel: 'Factuurregel', typeColor: Colors.infoBright}))
        ]
    }
}
